import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';

export const Route = createFileRoute('/_dashboard/users/$id/$tenantId')({
  beforeLoad: requireRoute('/users/$id/$tenantId'),
  component: Outlet,
});
